import styled from "@emotion/styled";
import { KonturColors } from "@skbkontur/colors";

const getBorder = (isScrolled: boolean): string => {
    if (isScrolled) {
        return `1px solid ${KonturColors.grayscaleBackground}`;
    }

    return "none";
};

export const UnitListUl = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const AttachmentsListUl = styled.ul`
    list-style: none;
    padding: 0;
`;

export const UnitListLi = styled.li`
    margin: 0 0 16px 0;

    &:last-child {
        margin: 0;
    }
`;

export const UnitListTitle = styled.h4`
    font-size: 16px;
    font-weight: 700;
    margin: 0 8px 0 0;
`;

export const AttachmentsItemLi = styled.li`
    margin: 0;
    padding: 6px 8px;
    display: flex;
    align-items: baseline;
    border-radius: 8px;
    box-sizing: border-box;
    width: 100%;

    &:hover {
        background-color: ${KonturColors.grayscaleLightBackground};
    }
`;

export const UnitSum = styled.p`
    font-size: 14px;
    color: ${KonturColors.grayscaleDisabledText};
    margin: 0 4px;
    text-wrap: nowrap;
`;

export const UnitListTitleIcon = styled.div<{ isActive: boolean }>`
    transition: 200ms;
    transform: rotate(${props => (props.isActive ? 0 : "-90deg")});
`;

export const DeleteBtnIcon = styled.div`
    color: ${KonturColors.grayscaleDisabledText};
    cursor: pointer;
    margin-left: 4px;

    &:hover {
        color: black;
    }
`;

export const UnitListHeader = styled.div`
    display: flex;
    align-items: baseline;
    padding: 6px 8px;
    transition: 200ms;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
        background-color: ${KonturColors.grayscaleLightBackground};
        transform: rotate(0);
    }

    ${DeleteBtnIcon} {
        margin-left: auto;
    }
`;

export const AttachmentsItemTitle = styled.div`
    margin: 0;
    flex-grow: 1;
`;

export const AttachmentsItemTitleText = styled.p<{ hasError: boolean }>`
    max-width: 100%;
    margin: 0;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    overflow: hidden;
    color: ${props => (props.hasError ? KonturColors.mainErrorTextRed90 : "#000")};
`;

export const AttachmentsItemInfo = styled.div`
    display: flex;
    align-items: baseline;
`;

export const ModalBodyList = styled.div<{ isScrolled: boolean }>`
    margin-top: 16px;
    border-top: ${props => getBorder(props.isScrolled)};
    border-bottom: ${props => getBorder(props.isScrolled)};
`;

export const UploadHintText = styled.p<{ isError?: boolean }>`
    margin: 0;
    padding: 6px 8px;
    color: ${props => (props.isError ? KonturColors.mainErrorTextRed90 : KonturColors.grayscaleSecondaryText)};
`;
